import { Pipe, PipeTransform } from '@angular/core';
import { DocExtension, DocType } from '../enums';

@Pipe({ name: 'docExt' })
export class DocExtensionPipe implements PipeTransform {
  transform(docType: DocType): string {
    return docType ? DocExtension[docType] : '';
  }
}
